import { render, staticRenderFns } from "./EditorInput.vue?vue&type=template&id=2b97931f&scoped=true"
import script from "./EditorInput.vue?vue&type=script&lang=js"
export * from "./EditorInput.vue?vue&type=script&lang=js"
import style0 from "./EditorInput.vue?vue&type=style&index=0&id=2b97931f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b97931f",
  null
  
)

export default component.exports